"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.videoSourceMapper = void 0;
const enum_mapper_1 = require("../utils/enum-mapper");
const globalTypes_1 = require("../private/generated/globalTypes");
const common_1 = require("@wix/wix-vod-constants/common");
exports.videoSourceMapper = new enum_mapper_1.EnumMapper({
    [globalTypes_1.VideoSource.COMPUTER]: common_1.VIDEO_SOURCES.COMPUTER,
    [globalTypes_1.VideoSource.YOUTUBE]: common_1.VIDEO_SOURCES.YOUTUBE,
    [globalTypes_1.VideoSource.FACEBOOK]: common_1.VIDEO_SOURCES.FACEBOOK,
    [globalTypes_1.VideoSource.VIMEO]: common_1.VIDEO_SOURCES.VIMEO,
    [globalTypes_1.VideoSource.LIVE]: common_1.VIDEO_SOURCES.LIVE,
    [globalTypes_1.VideoSource.GOOGLE_DRIVE]: common_1.VIDEO_SOURCES.GOOGLE_DRIVE,
    [globalTypes_1.VideoSource.DROPBOX]: common_1.VIDEO_SOURCES.DROPBOX,
});
//# sourceMappingURL=video-source.js.map